export const ENTITY_ANNOTATION_EXTENSION_TYPE = 'com.rovo.entity-annotation';
export const INFERRED_PROJECT_EXTENSION_KEY = 'inferred-project';

export type EntityAnnotationEntity = {
	type: string;
	mention: string;
	start: number;
	end: number;
	ari: string;
	canonicalName: string;
	confidenceScore: number;
};

export type EntityAnnotationBatch = {
	sentence: string;
	entities: readonly EntityAnnotationEntity[];
};
